import Spinner from '$components/Spinner/Spinner';
import { useEffect, useState } from 'react';

const SimeraIframe = ({
  iframeUrl,
  title,
}: {
  iframeUrl: string;
  title: string;
}) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
  }, [iframeUrl]);

  return (
    <div className="relative w-full h-full">
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/80 z-10">
          <Spinner />
        </div>
      )}

      <iframe
        src={iframeUrl}
        onLoad={() => setIsLoading(false)}
        title={title}
        className={`w-full h-full border-0 transition-opacity duration-300 ease-in-out ${
          isLoading ? 'opacity-0' : 'opacity-100'
        }`}
      />
    </div>
  );
};

export default SimeraIframe;
